export default "__VITE_ASSET__8feafb5c__"